
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class RacingRoundAbForm extends Vue {
  @Prop()
  form!: any

  @Prop()
  formFields!: any

  created () {
    if (process.env.NODE_ENV === 'development') {
      this.form.display_name = '回合'
      this.form.racing_track = 1
      this.form.promoted_number = 10
      this.form.start_rule = 1
    }
  }
}
